import axios from "axios";
import { setRedirectPath } from "../common/redirectPath";
import { clearSession, getToken } from "../auth/session";

const baseURL = process.env.REACT_APP_BASE_URL;

const axiosInstance = axios.create({
    baseURL,
    // Required: /images/download-presigned-url authorises CloudFront by setting
    // signed cookies on its response. A cross-origin response's Set-Cookie is only
    // honoured in credentials mode, so without this every image 403s.
    withCredentials: true,
    headers: {
        "Content-Type": "application/json",
    },
});

axiosInstance.interceptors.request.use(
    (config) => {
        const token = getToken();
        if (token) {
            config.headers["Authorization"] = `Bearer ${token}`;
        }
        return config;
    },
    (error) => Promise.reject(error),
);

//  Response Interceptor: catch 401 globally
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Came in from a link we sent them and the session had expired, so
      // remember it and send them back after they sign in again
        if (window.location.pathname.startsWith("/requests/")) {
            setRedirectPath(window.location.pathname);
        }

        clearSession();
        window.location.replace("/");
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;
